import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { LoginContext } from "../../context/login-context";

import { CustomButton } from "../custom-button";
import Icon from "../icon/icon";

import css from "./toggle-profile.module.css";

const ToggleProfile = ({ user }) => {
	// console.log("ToggleProfile user:", user);

	const navigate = useNavigate();
	const profileRef = useRef(null);

	const { logout } = useContext(LoginContext);

	const [showProfile, setShowProfile] = useState(false);

	const getUserRoleEls = (userRole) => {
		// if (userRole === "SUPER_ADMIN" || userRole === "VALMONT_REP") {
		// 	return false;
		// }
	

		return (
			<>

				{/* {user?.user_role == "FARM" &&
					<><div className={css.el}>
						{user?.farm?.strategic_acct?.name}
					</div><div className={css.el}>
							{user?.farm?.name}
						</div></>
				}

				{user?.user_role == "STRATEGIC_ACCOUNT" &&
					<><div className={css.el}>
						{user?.strategic_acct?.name}
					</div></>
				} */}
			</>
		);
	};

	const userInitials =
		user?.first_name?.charAt(0) + user?.last_name?.charAt(0);

	const handleClick = () => {
		if (window.innerWidth < 768) {
			return;
		}

		setShowProfile(!showProfile);
	};

	const handleLogout = (e) => {
		e.preventDefault();
		logout();
		navigate("/login");
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				profileRef.current &&
				!profileRef.current.contains(event.target)
			) {
				setShowProfile(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	});

	useEffect(() => {
		const mediaQuery = window.matchMedia("(max-width: 767px)");

		const handleViewportChange = (e) => {
			if (e.matches) {
				setShowProfile(true);
			} else {
				setShowProfile(showProfile);
			}
		};

		handleViewportChange(mediaQuery);
		mediaQuery.addEventListener("change", handleViewportChange);

		return () => {
			mediaQuery.removeEventListener("change", handleViewportChange);
		};
	});

	const profileInfo = (
		<div className={css.profileInfo}>
			<span>
				{user?.first_name} {user?.last_name}
			</span>
			<span className={css.email}>{user?.email}</span>
		</div>
	);

	const arrayExcludeUserRoles = ["SUPER_ADMIN", "VALMONT_REP"];
	const accountInfo = !arrayExcludeUserRoles.includes(user?.user_role) ? (
		<div className={css.accountInfo}>{getUserRoleEls(user?.user_role)}</div>
	) : null;

	const actions = (
		<div className={css.profileActions}>
			<CustomButton
				label="Logout"
				color="secondary"
				onClick={handleLogout}
				icon={<Icon icon="Logout" />}
			/>
		</div>
	);

	const profileBlock = (
		<div className={css.profileBlock}>
			{profileInfo}
			{accountInfo}
			{actions}
		</div>
	);

	const cssToggleBlock = `${css.toggleBlock} ${showProfile ? css.show : null}`;

	return (
		<div className={cssToggleBlock} ref={profileRef}>
			<CustomButton
				label={userInitials}
				color="secondary"
				onClick={handleClick}
			/>

			{showProfile && profileBlock}
		</div>
	);
};

export default ToggleProfile;
